import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from './main/main.component';
import { AuthGuard } from'@mydocma/auth';
import { SingleTabGuard } from '@mydocma/app-container';

export const routes: Routes = [
  {
    path: '',
    canActivate: [SingleTabGuard],
    component: MainComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../projects/mydocma/jf/src/lib/jf.module')
          .then(mod => mod.JfModule),
      }
    ],
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
